import React, { forwardRef, useRef } from 'react';
import { Checkbox } from 'antd';
import { INTEGRATION_TYPES } from '@model';

const MannualCheckbox = forwardRef((props, ref, ...args) => {
  const { onChange = () => {}, formChange = () => {} } = props;
  const inputRef = useRef(null);
  const rowType = props.formInstance?.getFieldValue?.([
    props.rowName,
    props.rowIndex,
  ])?.type;

  const onCombineChange = (...args) => {
    onChange(...args);
    formChange();
  };

  if (
    ['pdf', 'image', 'textContainer', INTEGRATION_TYPES.M365].includes(
      rowType,
    ) &&
    props.id.includes('iframe')
  ) {
    return (
      <Checkbox ref={inputRef} {...props} disabled onChange={onCombineChange} />
    );
  }
  if (['imageModule', 'widget', INTEGRATION_TYPES.HTML].includes(rowType)) {
    return (
      <Checkbox ref={inputRef} {...props} disabled onChange={onCombineChange} />
    );
  }
  if (rowType === 'multiSection') {
    return (
      <Checkbox ref={inputRef} {...props} disabled onChange={onCombineChange} />
    );
  }
  if (
    !props.shouldNotDisablePowerBI &&
    (rowType === 'powerbi' ||
      (rowType === 'powerbiModule' && props.id.includes('iframe')))
  ) {
    return (
      <Checkbox
        ref={inputRef}
        {...props}
        disabled
        className="powerbi-disabled-checkbox"
        onChange={onCombineChange}
      />
    );
  }
  return <Checkbox ref={inputRef} {...props} onChange={onCombineChange} />;
});
export default MannualCheckbox;
